import React, { Component } from "react";
import { connect } from "react-redux";
import "./index.css";
import { sendVerificationEmail, showProfileUpdateDimmer, hideEmailVerificationBanner } from "../../actions/userActions";
import { ONBOARDING_FIELDS } from "../../components/OnBoardingDimmer/constants";
import { Icon } from "semantic-ui-react";
class EmailVerificationBanner extends Component {
  render() {
    const { actions } = this.props;
    return (
      <div className="header-wrapper">
        <header className="verification-header">
          <div className="-header-wrapper">
            <div className="actions">
              <label className="-msg">
                We have sent you a confirmation email, please check it to verify your email address.
              </label>
              <ul className="-nav-bar">
                <li>
                  <a className="-button" onClick={actions.sendVerificationEmail}>
                    Resend confirmation
                  </a>
                </li>
                <li>
                  <a className="-button" onClick={actions.showProfileUpdateDimmer}>
                    Change email
                  </a>
                </li>
              </ul>
            </div>
            <div className="close-banner" onClick={actions.hideEmailVerificationBanner}>
              <Icon color="white" name="close" />
            </div>
          </div>
        </header>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    sendVerificationEmail: () => dispatch(sendVerificationEmail()),
    hideEmailVerificationBanner: () => dispatch(hideEmailVerificationBanner()),
    showProfileUpdateDimmer: () =>
      dispatch(
        showProfileUpdateDimmer({
          onboardingDisplayFields: [ONBOARDING_FIELDS.EMAIL],
          onboardingMessage: "Enter your most used email address",
        })
      ),
  },
});

export default connect(null, mapDispatchToProps)(EmailVerificationBanner);



// WEBPACK FOOTER //
// ./src/components/EmailVerificationBanner/index.js